var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "11px",
    viewBox: "0 0 15 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6C4435DD-1CBB-4D37-85D2-A6506D0F5C5A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change-Password--Settings",
    transform: "translate(-689.000000, -312.000000)",
    fill: "#ABB3C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(403.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(72.250000, 96.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(213.752310, 28.162500)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.48350855,
    cy: 4.83880125,
    r: 2.30419107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7373901,4.20054032 C12.966216,2.06023484 10.2851457,0 7.48350855,0 C4.68132419,0 1.99962021,2.06167496 0.229627041,4.20054032 C-0.0765423471,4.57036299 -0.0765423471,5.10723951 0.229627041,5.47706217 C0.674623942,6.01480277 1.6075333,7.05284084 2.85352462,7.95982805 C5.99151603,10.2442031 8.9685885,10.2492435 12.1134925,7.95982805 C13.3594838,7.05284084 14.2923932,6.01480277 14.7373901,5.47706217 C15.0426666,5.10795957 15.0442507,4.57157269 14.7373901,4.20054032 Z M7.48350855,1.61293375 C9.26234406,1.61293375 10.7093761,3.05996574 10.7093761,4.83880125 C10.7093761,6.61763675 9.26234406,8.06466875 7.48350855,8.06466875 C5.70467305,8.06466875 4.25764106,6.61763675 4.25764106,4.83880125 C4.25764106,3.05996574 5.70467305,1.61293375 7.48350855,1.61293375 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.39a0de8eb5424f6ea0d663bb1c8164f2.svg";
export { ForwardRef as ReactComponent };